module.exports = function isDate(obj){return obj instanceof Date;}


/*****************
 ** WEBPACK FOOTER
 ** ./lib/isDate.js
 ** module id = 13
 ** module chunks = 0
 **/